import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="share-patterns--table"
export default class extends Controller {
  static targets = ["table"];

  edit(event) {
    const badge = this.tableTarget.querySelector('tr span.badge');
    const row = event.currentTarget.closest('tr');
    const secondCell = row.children[1];

    if (badge && secondCell) {
      secondCell.append(badge);
    }
  }
}

